"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQueryParams = void 0;
var getQueryParams = function (search) {
    if (search === void 0) { search = window.location.search; }
    var queryString = search.replace(/^\?/, '');
    return !queryString
        ? {}
        : queryString.split('&').reduce(function (acc, pairString) {
            var _a;
            var _b = pairString.split('='), key = _b[0], value = _b[1];
            return __assign(__assign({}, acc), (_a = {}, _a[key] = value ? decodeURIComponent(value) : null, _a));
        }, {});
};
exports.getQueryParams = getQueryParams;
//# sourceMappingURL=queryParams.js.map